export enum StarSize {
  LARGE = 'lg',
  MEDIUM = 'md'
}
